<template>
  <div id="qr-code"></div>
</template>

<script>
/* global QRScanner */

import common from '@/utils/common'
import ConnectionService from '@/services/connection-service'

export default {
  name: 'QRcode',
  mixins: [common],
  created() {
    this.$parent.setNav(false)
    this.$parent.setHeader('')
    this.$parent.setBottomTab(false)

    this.performPrepareScanner()
  },
  beforeDestroy() {
    this.haltScanner()
  },
  methods: {
    performPrepareScanner() {
      QRScanner.prepare(this.onDone)
    },
    onDone(error, status) {
      if (error) {
        this.responseErrorQR(error['_message'])
      } else if (status.authorized) {
        // For iOS
        // document
        //   .getElementsByTagName('HTML')[0]
        //   .setAttribute('style', 'opacity: 0')

        QRScanner.show(() => {
          QRScanner.scan(this.displayContents)
        })
      } else if (status.denied) {
        // The video preview will remain black, and scanning is disabled. We can
        // try to ask the user to change their mind, but we'll have to send them
        // to their device settings with `QRScanner.openSettings()`.
        if (status.canOpenSettings) {
          navigator.notification.alert(
            'QR 코드 스캔을 사용하시겠습니까? 설정에서 카메라 접근을 허용할 수 있습니다.',
            this.openAppSettings,
            '경고',
            '확인'
          )
        }
      } else {
        // we didn't get permission, but we didn't get permanently denied. (On
        // Android, a denial isn't permanent unless the user checks the "Don't
        // ask again" box.) We can ask again at the next relevant opportunity.
        this.responseErrorQR('알 수 없는 오류.')
      }
    },
    displayContents(error, text) {
      if (error) {
        // an error occurred, or the scan was canceled (error code `6`)
        this.responseErrorQR(error)
      } else {
        // The scan completed, display the contents of the QR code:
        const clientURL = process.env.VUE_APP_CLIENT_URL
        if (text.startsWith(clientURL)) {
          const userCode = text.substring(text.lastIndexOf('/') + 1)
          if (!this.isEmpty(userCode)) {
            ConnectionService.inviteFromQRcode(userCode)
              .then(({ resultCode, resultMsg }) => {
                if (resultCode === 0) {
                  this.responseSuccessQR(resultMsg)
                } else {
                  this.responseErrorQR(resultMsg)
                }
              })
              .catch(error => {
                this.responseErrorQR(error)
              })
          } else {
            this.responseErrorQR('사용자 정보를 확인할 수 없습니다.')
          }
        } else {
          this.responseErrorQR('유효하지 않은 QR 코드 입니다.')
        }
      }
    },
    responseSuccessQR(resultMsg) {
      QRScanner.hide(() => {
        this.showToastMessage(resultMsg)
        this.goBack()
      })
    },
    responseErrorQR(message) {
      navigator.notification.alert(message, this.goBack, '오류', '종료')
    },
    openAppSettings() {
      QRScanner.openSettings()
    },
    haltScanner() {
      // QRScanner.pausePreview(status => {})
      // QRScanner.cancelScan(status => {})
      QRScanner.hide(() => {})
      QRScanner.destroy(() => {
        // For iOS
        document
          .getElementsByTagName('HTML')[0]
          // .setAttribute('style', 'opacity: 1')
          .setAttribute('style', 'background-color: white')
        document
          .getElementsByTagName('BODY')[0]
          .setAttribute('style', 'background-color: white')
      })
    },
    showToastMessage(message) {
      window.plugins.toast.showWithOptions({
        message,
        duration: 'short',
        position: 'bottom',
        addPixelsY: -100
      })
    }
  }
}
</script>

<style lang="scss">
#qr-code {
  padding: 0;
}
</style>
